import { FC } from 'react';
import {Container} from '@chakra-ui/react';
import {useRouter} from 'next/router';
import { BreadCrumb, BreadCrumbProps } from '@/components/BreadCrumb';
import { Layout } from '@/components/Layout';
import { graphqlClient } from '@/services/graphql-client';
import BeBookingForm from '@/components/BeForms/BeBookingForm';
import {PageCover} from '@/components/PageCover';
import {GetBookingPageQuery, getSdk} from '@/services/graphql';
import {useLocaleField} from '@/hooks/useLocaleField';
import styles from '@/styles/Home.module.css';

interface Props {
  bookingPageData: GetBookingPageQuery
}

const BookingPage: FC<Props> = ({ bookingPageData }) => {
  const { locale } = useRouter();
  const { getLocaleField } = useLocaleField();

  const breadcrumb: BreadCrumbProps['items'] = [
    {
      link: '/',
      title: locale === 'sq' ? 'Shtëpi' : 'Home',
    },
    {
      link: '/booking',
      title: getLocaleField(bookingPageData.BookingPage?.pageCover?.title) || '',
    },
  ];

  return (
    <Layout pageTitle={getLocaleField(bookingPageData.BookingPage?.pageCover?.title) || ''}>
      <main className={styles.main}>
        <PageCover data={bookingPageData.BookingPage?.pageCover} />
        <Container maxW="container.xl" my="25px">
          <BreadCrumb items={breadcrumb} />
          <BeBookingForm />
        </Container>
      </main>
    </Layout>
  );
};

export const getStaticProps = async () => {
  const sdk = getSdk(graphqlClient);
  const { data: bookingPageData } = await sdk.getBookingPage();

  return {
    props: {
      bookingPageData
    },
  };
};

export default BookingPage;
